//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export class ClientOptions {
    showLoading;
    constructor(showLoading = true) {
        this.showLoading = showLoading;
    }
}
export class ClientBase {
    constructor(options, baseUrl, http) { }
    async transformResult(url, response, processor) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => (_headers[k] = v));
        }
        if (status >= 200 && status < 300) {
            const _responseText = await response.text();
            let result200 = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText);
            return result200;
        }
        else if (status === 404) {
            const _responseText_1 = await response.text();
            return this.throwException("Resource not found.", status, _responseText_1, _headers);
        }
        else {
            const _responseText_2 = await response.text();
            let result_1 = null;
            if (_responseText_2) {
                try {
                    result_1 = JSON.parse(_responseText_2);
                    if (result_1?.ModelState) {
                        for (const error in result_1.ModelState) {
                            if (typeof result_1.ModelState[error] !== "undefined") {
                                result_1.message = result_1.ModelState[error];
                            }
                        }
                    }
                }
                catch (e) { }
            }
            return this.throwException(result_1
                ? result_1.message || result_1.Message
                : `An unexpected server error occurred when accessing ${url} : ${_responseText_2}`, status, _responseText_2, _headers);
        }
    }
    throwException(message, status, response, headers, result) {
        if (result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response, headers, null);
    }
}
export class Client extends ClientBase {
    http;
    baseUrl;
    jsonParseReviver = undefined;
    constructor(configuration, baseUrl, http) {
        super(configuration);
        this.http = http ? http : window;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Get user info.
     * @return OK
     */
    accounts_GetUserInfo() {
        let url_ = this.baseUrl + "/api/v1/Accounts/UserInfo";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAccounts_GetUserInfo(_response);
        });
    }
    processAccounts_GetUserInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get user info.
     * @param x_Api_Version (optional)
     * @return OK
     */
    accounts_GetUserInfo2(x_Api_Version) {
        let url_ = this.baseUrl + "/api/Account/UserInfo";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAccounts_GetUserInfo2(_response);
        });
    }
    processAccounts_GetUserInfo2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get user info.
     * @return OK
     */
    accounts_GetUserInfo_v2() {
        let url_ = this.baseUrl + "/api/v2/Accounts/UserInfo";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAccounts_GetUserInfo_v2(_response);
        });
    }
    processAccounts_GetUserInfo_v2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets broadcasts by ids.
     * @param broadcastIds (optional) The broadcast ids.
     * @return OK
     */
    broadcasts_GetBroadcastsByIds(broadcastIds) {
        let url_ = this.baseUrl + "/api/v1/Broadcasts/ByIds?";
        if (broadcastIds === null)
            throw new Error("The parameter 'broadcastIds' cannot be null.");
        else if (broadcastIds !== undefined)
            broadcastIds && broadcastIds.forEach(item => { url_ += "broadcastIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processBroadcasts_GetBroadcastsByIds(_response);
        });
    }
    processBroadcasts_GetBroadcastsByIds(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets broadcasts by filter.
     * @param searchId Gets or sets the search id.
     * @param pageNo (optional) Gets or sets the page no.
     * @param pageSize (optional) Gets or sets the page size.
     * @param searchType (optional) Gets or sets the search type.
     * @param videoStatusType (optional) Gets or sets the video status type.
     * @param textQuery (optional) Gets or sets the text query.
     * @param categoryIds (optional) Gets or sets the category ids.
     * @param filterType (optional) Gets or sets the filter type.
     * @param sortType (optional) Gets or sets the sort type.
     * @param sortOrder (optional) Gets or sets the sort order.
     * @param excludedPlayerIds (optional) Gets or sets the excluded player ids.
     * @return OK
     */
    broadcasts_GetPagedBroadcastsByFilter(searchId, pageNo, pageSize, searchType, videoStatusType, textQuery, categoryIds, filterType, sortType, sortOrder, excludedPlayerIds) {
        let url_ = this.baseUrl + "/api/v1/Broadcasts/ByFilter?";
        if (searchId === undefined || searchId === null)
            throw new Error("The parameter 'searchId' must be defined and cannot be null.");
        else
            url_ += "SearchId=" + encodeURIComponent("" + searchId) + "&";
        if (pageNo === null)
            throw new Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "PageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "SearchType=" + encodeURIComponent("" + searchType) + "&";
        if (videoStatusType === null)
            throw new Error("The parameter 'videoStatusType' cannot be null.");
        else if (videoStatusType !== undefined)
            url_ += "VideoStatusType=" + encodeURIComponent("" + videoStatusType) + "&";
        if (textQuery === null)
            throw new Error("The parameter 'textQuery' cannot be null.");
        else if (textQuery !== undefined)
            url_ += "TextQuery=" + encodeURIComponent("" + textQuery) + "&";
        if (categoryIds === null)
            throw new Error("The parameter 'categoryIds' cannot be null.");
        else if (categoryIds !== undefined)
            categoryIds && categoryIds.forEach(item => { url_ += "CategoryIds=" + encodeURIComponent("" + item) + "&"; });
        if (filterType === null)
            throw new Error("The parameter 'filterType' cannot be null.");
        else if (filterType !== undefined)
            url_ += "FilterType=" + encodeURIComponent("" + filterType) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (sortOrder === null)
            throw new Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (excludedPlayerIds === null)
            throw new Error("The parameter 'excludedPlayerIds' cannot be null.");
        else if (excludedPlayerIds !== undefined)
            excludedPlayerIds && excludedPlayerIds.forEach(item => { url_ += "ExcludedPlayerIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processBroadcasts_GetPagedBroadcastsByFilter(_response);
        });
    }
    processBroadcasts_GetPagedBroadcastsByFilter(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get or create singleton.
     * @param body (optional) The request.
     * @return OK
     */
    broadcasts_GetOrCreateSingleton(body) {
        let url_ = this.baseUrl + "/api/v1/Broadcasts/Singleton";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processBroadcasts_GetOrCreateSingleton(_response);
        });
    }
    processBroadcasts_GetOrCreateSingleton(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets broadcasts by id.
     * @param broadcastId The broadcast id.
     * @return OK
     */
    broadcasts_GetBroadcastsById(broadcastId) {
        let url_ = this.baseUrl + "/api/v2/Broadcasts/{broadcastId}";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processBroadcasts_GetBroadcastsById(_response);
        });
    }
    processBroadcasts_GetBroadcastsById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete facebook request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    facebookProxy_ProxyGET(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/Facebook/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFacebookProxy_ProxyGET(_response);
        });
    }
    processFacebookProxy_ProxyGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete facebook request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    facebookProxy_ProxyPOST(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/Facebook/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFacebookProxy_ProxyPOST(_response);
        });
    }
    processFacebookProxy_ProxyPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete facebook request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    facebookProxy_ProxyPUT(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/Facebook/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFacebookProxy_ProxyPUT(_response);
        });
    }
    processFacebookProxy_ProxyPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete facebook request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    facebookProxy_ProxyPATCH(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/Facebook/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFacebookProxy_ProxyPATCH(_response);
        });
    }
    processFacebookProxy_ProxyPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete facebook request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    facebookProxy_ProxyDELETE(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/Facebook/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFacebookProxy_ProxyDELETE(_response);
        });
    }
    processFacebookProxy_ProxyDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get react bundles (legacy model).
     * @return OK
     */
    reactBundles_GetReactBundles() {
        let url_ = this.baseUrl + "/api/v1/ReactBundles";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processReactBundles_GetReactBundles(_response);
        });
    }
    processReactBundles_GetReactBundles(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get react bundles (legacy model).
     * @param appId The app id.
     * @param x_Api_Version (optional)
     * @return OK
     */
    reactBundles_GetReactBundles2(appId, x_Api_Version) {
        let url_ = this.baseUrl + "/api/Apps/{appId}/ReactBundles";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processReactBundles_GetReactBundles2(_response);
        });
    }
    processReactBundles_GetReactBundles2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get react bundle (legacy model).
     * @param bundleId The bundle id.
     * @return OK
     */
    reactBundles_GetReactBundle(bundleId) {
        let url_ = this.baseUrl + "/api/v1/ReactBundles/{bundleId}";
        if (bundleId === undefined || bundleId === null)
            throw new Error("The parameter 'bundleId' must be defined.");
        url_ = url_.replace("{bundleId}", encodeURIComponent("" + bundleId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processReactBundles_GetReactBundle(_response);
        });
    }
    processReactBundles_GetReactBundle(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get react bundle (legacy model).
     * @param bundleId The bundle id.
     * @param x_Api_Version (optional)
     * @return OK
     */
    reactBundles_GetReactBundle2(bundleId, appId, x_Api_Version) {
        let url_ = this.baseUrl + "/api/Apps/{appId}/ReactBundles/{bundleId}";
        if (bundleId === undefined || bundleId === null)
            throw new Error("The parameter 'bundleId' must be defined.");
        url_ = url_.replace("{bundleId}", encodeURIComponent("" + bundleId));
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processReactBundles_GetReactBundle2(_response);
        });
    }
    processReactBundles_GetReactBundle2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get latest react bundle (legacy model).
     * @param apiVersion (optional) The api version.
     * @param appVersion (optional) The app version.
     * @param isTestFlight (optional) If true, is test flight.
     * @return OK
     */
    reactBundles_GetLatestReactBundle(apiVersion, appVersion, isTestFlight) {
        let url_ = this.baseUrl + "/api/v1/ReactBundles/Latest?";
        if (apiVersion === null)
            throw new Error("The parameter 'apiVersion' cannot be null.");
        else if (apiVersion !== undefined)
            url_ += "apiVersion=" + encodeURIComponent("" + apiVersion) + "&";
        if (appVersion === null)
            throw new Error("The parameter 'appVersion' cannot be null.");
        else if (appVersion !== undefined)
            url_ += "appVersion=" + encodeURIComponent("" + appVersion) + "&";
        if (isTestFlight === null)
            throw new Error("The parameter 'isTestFlight' cannot be null.");
        else if (isTestFlight !== undefined)
            url_ += "isTestFlight=" + encodeURIComponent("" + isTestFlight) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processReactBundles_GetLatestReactBundle(_response);
        });
    }
    processReactBundles_GetLatestReactBundle(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get latest react bundle (legacy model).
     * @param appId The app id.
     * @param apiVersion (optional) The api version.
     * @param appVersion (optional) The app version.
     * @param isTestFlight (optional) If true, is test flight.
     * @param x_Api_Version (optional)
     * @return OK
     */
    reactBundles_GetLatestReactBundle2(appId, apiVersion, appVersion, isTestFlight, x_Api_Version) {
        let url_ = this.baseUrl + "/api/Apps/{appId}/ReactBundles/Latest?";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        if (apiVersion === null)
            throw new Error("The parameter 'apiVersion' cannot be null.");
        else if (apiVersion !== undefined)
            url_ += "apiVersion=" + encodeURIComponent("" + apiVersion) + "&";
        if (appVersion === null)
            throw new Error("The parameter 'appVersion' cannot be null.");
        else if (appVersion !== undefined)
            url_ += "appVersion=" + encodeURIComponent("" + appVersion) + "&";
        if (isTestFlight === null)
            throw new Error("The parameter 'isTestFlight' cannot be null.");
        else if (isTestFlight !== undefined)
            url_ += "isTestFlight=" + encodeURIComponent("" + isTestFlight) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processReactBundles_GetLatestReactBundle2(_response);
        });
    }
    processReactBundles_GetLatestReactBundle2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get react bundles.
     * @param appId (optional) The app id.
     * @return OK
     */
    reactBundles_GetReactBundles_v2(appId) {
        let url_ = this.baseUrl + "/api/v2/ReactBundles?";
        if (appId === null)
            throw new Error("The parameter 'appId' cannot be null.");
        else if (appId !== undefined)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processReactBundles_GetReactBundles_v2(_response);
        });
    }
    processReactBundles_GetReactBundles_v2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get react bundle.
     * @param bundleId The bundle id.
     * @return OK
     */
    reactBundles_GetReactBundle_v2(bundleId) {
        let url_ = this.baseUrl + "/api/v2/ReactBundles/{bundleId}";
        if (bundleId === undefined || bundleId === null)
            throw new Error("The parameter 'bundleId' must be defined.");
        url_ = url_.replace("{bundleId}", encodeURIComponent("" + bundleId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processReactBundles_GetReactBundle_v2(_response);
        });
    }
    processReactBundles_GetReactBundle_v2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get latest react bundle.
     * @param appId (optional) The app id.
     * @param apiVersion (optional) The api version.
     * @param appVersion (optional) The app version.
     * @param isTestFlight (optional) If true, is test flight.
     * @return OK
     */
    reactBundles_GetLatestReactBundle_v2(appId, apiVersion, appVersion, isTestFlight) {
        let url_ = this.baseUrl + "/api/v2/ReactBundles/Latest?";
        if (appId === null)
            throw new Error("The parameter 'appId' cannot be null.");
        else if (appId !== undefined)
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        if (apiVersion === null)
            throw new Error("The parameter 'apiVersion' cannot be null.");
        else if (apiVersion !== undefined)
            url_ += "apiVersion=" + encodeURIComponent("" + apiVersion) + "&";
        if (appVersion === null)
            throw new Error("The parameter 'appVersion' cannot be null.");
        else if (appVersion !== undefined)
            url_ += "appVersion=" + encodeURIComponent("" + appVersion) + "&";
        if (isTestFlight === null)
            throw new Error("The parameter 'isTestFlight' cannot be null.");
        else if (isTestFlight !== undefined)
            url_ += "isTestFlight=" + encodeURIComponent("" + isTestFlight) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processReactBundles_GetLatestReactBundle_v2(_response);
        });
    }
    processReactBundles_GetLatestReactBundle_v2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Creates a schedule by its ID.
     * @return OK
     */
    stripe_CreateScheduleById(body) {
        let url_ = this.baseUrl + "/api/v1/Stripe/Schedule";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processStripe_CreateScheduleById(_response);
        });
    }
    processStripe_CreateScheduleById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a schedule by its ID.
     * @param scheduleId The unique identifier of the schedule.
     * @return OK
     */
    stripe_GetScheduleById(scheduleId) {
        let url_ = this.baseUrl + "/api/v1/Stripe/Schedule/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processStripe_GetScheduleById(_response);
        });
    }
    processStripe_GetScheduleById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a schedule by its ID.
     * @param scheduleId The Id of the schedule to update
     * @param body The request to update a schedule.
     * @return OK
     */
    stripe_UpdateScheduleById(scheduleId, body) {
        let url_ = this.baseUrl + "/api/v1/Stripe/Schedule/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processStripe_UpdateScheduleById(_response);
        });
    }
    processStripe_UpdateScheduleById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Retrieves a schedule by its ID.
     * @param subscriptionId The unique identifier of the subscription.
     * @return OK
     */
    stripe_GetScheduleBySubscriptionId(subscriptionId) {
        let url_ = this.baseUrl + "/api/v1/Stripe/Schedule/BySubscriptionId/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processStripe_GetScheduleBySubscriptionId(_response);
        });
    }
    processStripe_GetScheduleBySubscriptionId(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Cancels a schedule by its ID. Also cancels underlying subscription. Should be used instead of the subscription cancel if there is a schedule (paused or not) attached to the subscription.
     * @param scheduleId The Id of the schedule to cancel.
     * @return OK
     */
    stripe_DeleteScheduleById(scheduleId) {
        let url_ = this.baseUrl + "/api/v1/Stripe/Schedule/{scheduleId}/Cancel";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processStripe_DeleteScheduleById(_response);
        });
    }
    processStripe_DeleteScheduleById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Release a schedule
     * @param scheduleId The Id of the schedule to release.
     * @return OK
     */
    stripe_ReleaseScheduleById(scheduleId) {
        let url_ = this.baseUrl + "/api/v1/Stripe/Schedule/{scheduleId}/Release";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processStripe_ReleaseScheduleById(_response);
        });
    }
    processStripe_ReleaseScheduleById(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get user's Stripe Account Session by user id.
     * @return OK
     */
    stripeConnect_GetAccountSession(userId) {
        let url_ = this.baseUrl + "/api/v1/StripeConnect/Users/{userId}/AccountSession";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processStripeConnect_GetAccountSession(_response);
        });
    }
    processStripeConnect_GetAccountSession(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Handles Stripe webhooks.
     * @return OK
     */
    stripeWebhooks_HandleWebhook() {
        let url_ = this.baseUrl + "/api/v2/StripeWebhooks";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {}
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processStripeWebhooks_HandleWebhook(_response);
        });
    }
    processStripeWebhooks_HandleWebhook(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * TODO: Add Summary.
     * @param x_Api_Version (optional)
     * @return OK
     */
    test_Error(x_Api_Version) {
        let url_ = this.baseUrl + "/api/Test/error";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTest_Error(_response);
        });
    }
    processTest_Error(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the secret.
     * @param x_Api_Version (optional)
     * @return OK
     */
    test_GetSecret(x_Api_Version) {
        let url_ = this.baseUrl + "/api/Test/secret";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTest_GetSecret(_response);
        });
    }
    processTest_GetSecret(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the hello.
     * @param x_Api_Version (optional)
     * @return OK
     */
    test_GetHello(x_Api_Version) {
        let url_ = this.baseUrl + "/api/Test/hello";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTest_GetHello(_response);
        });
    }
    processTest_GetHello(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete twitch request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    twitchProxy_ProxyGET(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTwitchProxy_ProxyGET(_response);
        });
    }
    processTwitchProxy_ProxyGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete twitch request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    twitchProxy_ProxyPOST(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTwitchProxy_ProxyPOST(_response);
        });
    }
    processTwitchProxy_ProxyPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete twitch request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    twitchProxy_ProxyPUT(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTwitchProxy_ProxyPUT(_response);
        });
    }
    processTwitchProxy_ProxyPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete twitch request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    twitchProxy_ProxyPATCH(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTwitchProxy_ProxyPATCH(_response);
        });
    }
    processTwitchProxy_ProxyPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete twitch request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    twitchProxy_ProxyDELETE(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/Twitch/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processTwitchProxy_ProxyDELETE(_response);
        });
    }
    processTwitchProxy_ProxyDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete youtube request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    youTubeProxy_ProxyGET(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processYouTubeProxy_ProxyGET(_response);
        });
    }
    processYouTubeProxy_ProxyGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete youtube request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    youTubeProxy_ProxyPOST(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processYouTubeProxy_ProxyPOST(_response);
        });
    }
    processYouTubeProxy_ProxyPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete youtube request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    youTubeProxy_ProxyPUT(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PUT",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processYouTubeProxy_ProxyPUT(_response);
        });
    }
    processYouTubeProxy_ProxyPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete youtube request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    youTubeProxy_ProxyPATCH(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processYouTubeProxy_ProxyPATCH(_response);
        });
    }
    processYouTubeProxy_ProxyPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get/Post/Put/Patch/Delete youtube request.
     * @param url The url.
     * @param x_Api_Version (optional)
     * @return OK
     */
    youTubeProxy_ProxyDELETE(url, x_Api_Version) {
        let url_ = this.baseUrl + "/api/StreamingProviders/YouTube/Proxy/{url}";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "X-Api-Version": x_Api_Version !== undefined && x_Api_Version !== null ? "" + x_Api_Version : "",
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processYouTubeProxy_ProxyDELETE(_response);
        });
    }
    processYouTubeProxy_ProxyDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class SwaggerException extends Error {
    message;
    status;
    response;
    headers;
    result;
    constructor(message, status, response, headers, result) {
        super();
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    isSwaggerException = true;
    static isSwaggerException(obj) {
        return obj.isSwaggerException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}
